import React from "react";

export const InstructionsContainer = props => (
  <div className="instructions-container">
    <p className="text-muted small" style={{lineHeight: 1.2}}>
      {props.children}
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Instructions/index.jsx